module.exports = __webpack_public_path__ + "src/routes/solution/img1.png?a774ddf1";


//////////////////
// WEBPACK FOOTER
// ./src/routes/solution/img1.png
// module id = 2870
// module chunks = 1